/**
 * base64 encoder and decoder
 * Copied and adapted from https://github.com/protobufjs/protobuf.js/blob/master/lib/base64/index.js
 */
// Base64 encoding table
const b64 = new Array(64);

// Base64 decoding table
const s64 = new Array(123);

// 65..90, 97..122, 48..57, 43, 47
for (let i = 0; i < 64; )
  s64[
    (b64[i] =
      i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : (i - 59) | 43)
  ] = i++;

export function b64Encode(
  buffer: Uint8Array,
  start: number,
  end: number
): string {
  let parts: string[] | null = null;
  const chunk: number[] = [];
  let i = 0, // output index
    j = 0, // goto index
    t; // temporary
  while (start < end) {
    const b = buffer[start++];
    switch (j) {
      case 0:
        chunk[i++] = b64[b >> 2];
        t = (b & 3) << 4;
        j = 1;
        break;
      case 1:
        // @ts-ignore
        chunk[i++] = b64[t | (b >> 4)];
        t = (b & 15) << 2;
        j = 2;
        break;
      case 2:
        // @ts-ignore
        chunk[i++] = b64[t | (b >> 6)];
        chunk[i++] = b64[b & 63];
        j = 0;
        break;
    }
    if (i > 8191) {
      (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
      i = 0;
    }
  }
  if (j) {
    // @ts-ignore
    chunk[i++] = b64[t];
    chunk[i++] = 61;
    if (j === 1) chunk[i++] = 61;
  }
  if (parts) {
    if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
    return parts.join("");
  }
  return String.fromCharCode.apply(String, chunk.slice(0, i));
}

const invalidEncoding = "invalid encoding";

export function b64Decode(s: string): Uint8Array {
  const buffer: number[] = [];
  let offset = 0;
  let j = 0, // goto index
    t; // temporary
  for (let i = 0; i < s.length; ) {
    let c = s.charCodeAt(i++);
    if (c === 61 && j > 1) break;
    if ((c = s64[c]) === undefined) throw Error(invalidEncoding);
    switch (j) {
      case 0:
        t = c;
        j = 1;
        break;
      case 1:
        // @ts-ignore
        buffer[offset++] = (t << 2) | ((c & 48) >> 4);
        t = c;
        j = 2;
        break;
      case 2:
        // @ts-ignore
        buffer[offset++] = ((t & 15) << 4) | ((c & 60) >> 2);
        t = c;
        j = 3;
        break;
      case 3:
        // @ts-ignore
        buffer[offset++] = ((t & 3) << 6) | c;
        j = 0;
        break;
    }
  }
  if (j === 1) throw Error(invalidEncoding);
  return new Uint8Array(buffer);
}

export function replacer(_: any, value: any): any {
  if (value && value.constructor === Uint8Array) {
    return b64Encode(value, 0, value.length);
  }

  return value;
}

export const supportsRequestStreams = (() => {
  let duplexAccessed = false;

  const hasContentType = new Request("", {
    body: new ReadableStream(),
    method: "POST",
    // @ts-ignore
    get duplex() {
      duplexAccessed = true;
      return "half";
    },
  }).headers.has("Content-Type");

  return duplexAccessed && !hasContentType;
})();

type ValueOf<T> = T[keyof T];
type OneOnly<T, K extends keyof T> = {
  [key in Exclude<keyof T, K>]?: T[key];
} & { [key in K]: T[K] };
type OneOfByKey<T> = { [key in keyof T]: OneOnly<T, key> };
export type OneOf<T> = ValueOf<OneOfByKey<T>>;
export type OptionalOneOf<T> = OneOf<T> | {};

export async function request<TRequest, TResponse>(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<TResponse> {
  const result = await fetch(input, init);
  if (!result.ok) {
    const response = await result.json();
    const error = response.error ? response.error : response;
    throw error;
  }

  const response = await result.json();
  return response;
}

export async function array<TRequest, TResponse>(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<StreamItem<TResponse>[]> {
  const result = await fetch(input, init);
  if (!result.ok) {
    const response = await result.json();
    const error = response.error ? response.error : response;
    throw error;
  }

  const items: StreamItem<TResponse>[] = [];
  if (result.body) {
    const nextHandler = (item: StreamItem<TResponse>) => {
      if (item.error) {
        throw item.error;
      } else if (item.result) {
        items.push(item);
      }
    };
    const outputStream = result.body
      .pipeThrough(new TextDecoderStream())
      .pipeThrough<StreamItem<TResponse>>(
        CreateJsonDecoderStream<TResponse>(nextHandler, init?.signal)
      );

    // https://deno.com/blog/every-web-api-in-deno#transformstream
    // Type 'ReadableStream<StreamItem<TResponse>>' must have a '[Symbol.asyncIterator]()' method that returns an async iterator.ts(2504)

    await outputStream.pipeTo(new WritableStream());
  }
  return items;
}

export async function list<TRequest, TResponse>(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<TResponse[]> {
    const result = await fetch(input, init);
    if (!result.ok) {
      const response = await result.json();
      const error = response.error ? response.error : response;
      throw error;
    }

    const items: TResponse[] = [];
    if (result.body) {
      const nextHandler = (item: StreamItem<TResponse>) => {
        if (item.error) {
          throw item.error;
        } else if (item.result) {
          items.push(item.result);
        }
      };
      const outputStream = result.body
        .pipeThrough(new TextDecoderStream())
        .pipeThrough<StreamItem<TResponse>>(
          CreateJsonDecoderStream<TResponse>(nextHandler, init?.signal)
        );

      // https://deno.com/blog/every-web-api-in-deno#transformstream
      // Type 'ReadableStream<StreamItem<TResponse>>' must have a '[Symbol.asyncIterator]()' method that returns an async iterator.ts(2504)

      await outputStream.pipeTo(new WritableStream());
    }
    return items;
}

export type ApiError = {
  readonly code: number;
  readonly message: string;
  readonly details: ApiErrorDetail[];
};

/**
 * https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#empty
 */
export type Empty = Record<string, never> | null;

/**
 * https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#any
 */
export type Any =
  | ({ readonly "@type": string } & { readonly [key: string]: string })
  | null;

/**
 * https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#value
 */
export type Value =
  | null
  | number
  | string
  | boolean
  | { [key: string]: Value }
  | Value[];

export type ApiErrorDetail = { readonly "@type": string } & {
  readonly [key: string]: string;
};

export type StreamItem<TResponse> = OneOf<{
  readonly result: TResponse;
  readonly error: ApiError;
}>;

export type StreamNext<TResponse> = (item: StreamItem<TResponse>) => void;

export async function stream<TRequest, TResponse>(
  next: StreamNext<TResponse>,
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<void> {
  const result = await fetch(input, init);
  if (!result.ok) {
    const response = await result.json();
    const error = response.error ? response.error : response;
    throw error;
  }

  if (result.body) {
    let outputStream = result.body
      .pipeThrough(new TextDecoderStream())
      .pipeThrough<StreamItem<TResponse>>(
        CreateJsonDecoderStream<TResponse>(next, init?.signal)
      );

    // https://deno.com/blog/every-web-api-in-deno#transformstream
    // Type 'ReadableStream<StreamItem<TResponse>>' must have a '[Symbol.asyncIterator]()' method that returns an async iterator.ts(2504)

    return await outputStream.pipeTo(new WritableStream());
  }
}

export type Subscription<TRequest, TResponse> = {
  start: () => Subscription<TRequest, TResponse>;
  // send: (request: TRequest) => Subscription<TRequest, TResponse>
  unsubscribe: (reason?: any) => void;
  onStart: (startHandler: () => void) => Subscription<TRequest, TResponse>;
  onNext: (
    nextHandler: (item: StreamItem<TResponse>) => void
  ) => Subscription<TRequest, TResponse>;
  onComplete: (
    completeHandler: () => void
  ) => Subscription<TRequest, TResponse>;
  onAbort: (
    abortHandler: (reason: any) => void
  ) => Subscription<TRequest, TResponse>;
  onError: (
    errorHandler: (reason: any) => void
  ) => Subscription<TRequest, TResponse>;
};

export function subscribe<TRequest, TResponse>(
  input: RequestInfo | URL,
  init?: RequestInit,
  _abortController?: AbortController
): Subscription<TRequest, TResponse> {
  const abortController = _abortController ?? new AbortController();
  let started = false;
  let _startHandler: (() => void) | null = null;
  // let _sendHandler: (request: TRequest) => void;
  let _nextHandler: StreamNext<TResponse> | null = null;
  let _completeHandler: (() => void) | null = null;
  let _abortHandler: ((reason: any) => void) | null = null;
  let _errorHandler: ((reason: any) => void) | null = null;
  const abortableNextHandler = (item: StreamItem<TResponse>) => {
    !abortController.signal.aborted && _nextHandler && _nextHandler(item);
  };
  const subscription = {
    start: () => {
      if (!abortController.signal.aborted) {
        if (!started) {
          started = true;
          setTimeout(async () => {
            try {
              _startHandler && _startHandler();

              await stream<TRequest, TResponse>(abortableNextHandler, input, {
                ...init,
                ...{ signal: abortController.signal },
              });

              _completeHandler && _completeHandler();
            } catch (reason) {
              if (
                reason instanceof DOMException &&
                reason.name == "AbortError"
              ) {
                _abortHandler && _abortHandler(abortController.signal.reason);
              } else {
                _errorHandler && _errorHandler(reason);
              }
            }
          }, 0);
        } else {
          console.warn("Subscription already started");
        }
      } else {
        console.warn("Subscription already aborted");
      }
      return subscription;
    },
    // send: (request: TRequest) => {
    //   if (!supportsRequestStreams) {
    //     console.warn("Fetch half duplex not supported")
    //     return subscription;
    //   }

    //   _sendHandler && _sendHandler(request)

    //   return subscription
    // },
    unsubscribe: (reason: any = "unsubscribe") => {
      if (abortController.signal.aborted) {
        console.warn("Subscription already aborted");
      } else {
        abortController.abort(reason);
      }
    },
    onStart: (startHandler: (request?: TRequest) => void) => {
      _startHandler = startHandler;
      return subscription;
    },
    onNext: (nextHandler: StreamNext<TResponse>) => {
      _nextHandler = nextHandler;
      return subscription;
    },
    onComplete: (completeHandler: () => void) => {
      _completeHandler = completeHandler;
      return subscription;
    },
    onAbort: (abortHandler: (reason: any) => void) => {
      _abortHandler = abortHandler;
      return subscription;
    },
    onError: (errorHandler: (reason: any) => void) => {
      _errorHandler = errorHandler;
      return subscription;
    },
  };
  return subscription;
}

interface JsonStringStreamController<T>
  extends TransformStreamDefaultController {
  buf?: string;
  pos?: number;
  enqueue: (response: T) => void;
}

type SimpleController = {
  buf: string;
  pos: number;
};

function getLine(controller: SimpleController): string {
  if (controller.buf[0] === "," || controller.buf[0] === "[") {
    if (
      controller.buf[controller.pos - 1] === "," ||
      controller.buf[controller.pos - 1] === "]"
    ) {
      return controller.buf.substring(1, controller.pos - 1);
    }
    return controller.buf.substring(1, controller.pos);
  } else if (
    controller.buf[controller.pos - 1] === "," ||
    controller.buf[controller.pos - 1] === "]"
  ) {
    return controller.buf.substring(0, controller.pos - 1);
  }
  return controller.buf.substring(0, controller.pos);
}

function CreateJsonDecoderStream<TResponse>(
  next: StreamNext<TResponse>,
  signal?: AbortSignal | null
): TransformStream<string, StreamItem<TResponse>> {
  return new TransformStream({
    start(controller: JsonStringStreamController<StreamItem<TResponse>>) {
      controller.buf = "";
      controller.pos = 0;
    },

    transform(
      chunk: string,
      controller: JsonStringStreamController<StreamItem<TResponse>>
    ) {
      if (controller.buf === undefined) {
        controller.buf = "";
      }
      if (controller.pos === undefined) {
        controller.pos = 0;
      }

      controller.buf += chunk;
      while (controller.pos < controller.buf.length) {
        if (signal && signal.aborted) {
          break;
        }

        if (controller.buf[controller.pos] === "\n") {
          if (
            controller.pos !== 1 &&
            controller.pos + 1 != controller.buf.length
          ) {
            const line = getLine(controller as SimpleController);
            const json: StreamItem<TResponse> = JSON.parse(line);
            next(json);
          }
          controller.buf = controller.buf.substring(controller.pos + 1);
          controller.pos = 0;
        } else {
          ++controller.pos;
        }
      }
    },
  });
}

type Primitive = string | boolean | number;
type RequestPayload = Record<string, unknown>;
type FlattenedRequestPayload = Record<string, Primitive | Array<Primitive>>;

/**
 * Checks if given value is a plain object
 * Logic copied and adapted from below source:
 * https://github.com/char0n/ramda-adjunct/blob/master/src/isPlainObj.js
 * @param  {unknown} value
 * @return {boolean}
 */
function isPlainObject(value: unknown): boolean {
  const isObject =
    Object.prototype.toString.call(value).slice(8, -1) === "Object";
  const isObjLike = value !== null && isObject;

  if (!isObjLike || !isObject) {
    return false;
  }

  const proto = Object.getPrototypeOf(value);

  const hasObjectConstructor =
    typeof proto === "object" &&
    proto.constructor === Object.prototype.constructor;

  return hasObjectConstructor;
}

/**
 * Checks if given value is of a primitive type
 * @param  {unknown} value
 * @return {boolean}
 */
function isPrimitive(value: unknown): boolean {
  return ["string", "number", "boolean"].some((t) => typeof value === t);
}

/**
 * Flattens a deeply nested request payload and returns an object
 * with only primitive values and non-empty array of primitive values
 * as per https://github.com/googleapis/googleapis/blob/master/google/api/http.proto
 * @param  {RequestPayload} requestPayload
 * @param  {String} path
 * @return {FlattenedRequestPayload}
 */
export function flattenRequestPayload<T extends RequestPayload>(
  requestPayload: T = {} as T,
  path: string = ""
): FlattenedRequestPayload {
  return Object.keys(requestPayload).reduce((acc: T, key: string): T => {
    const value = requestPayload[key];
    const newPath = path ? [path, key].join(".") : key;

    const isNonEmptyPrimitiveArray =
      Array.isArray(value) &&
      value.every((v) => isPrimitive(v)) &&
      value.length > 0;


    let objectToMerge = {};

    if (isPlainObject(value)) {
      objectToMerge = flattenRequestPayload(value as RequestPayload, newPath);
    } else if (isPrimitive(value) || isNonEmptyPrimitiveArray) {
      objectToMerge = { [newPath]: value };
    }

    return { ...acc, ...objectToMerge };
  }, {} as T) as FlattenedRequestPayload;
}

export function buildQuery<T extends RequestPayload>(
  requestPayload: T = {} as T,
  urlPathParams: string[] = []
): string {
  const flattenedRequestPayload = flattenRequestPayload(requestPayload);

  const urlSearchParams = Object.keys(flattenedRequestPayload).reduce(
    (acc: string[][], key: string): string[][] => {
      // key should not be present in the url path as a parameter
      const value = flattenedRequestPayload[key];
      if (urlPathParams.find((f) => f === key)) {
        return acc;
      }
      return Array.isArray(value)
        ? [...acc, ...value.map((p) => [key, p.toString()])]
        : (acc = [...acc, [key, value.toString()]]);
    },
    [] as string[][]
  );

  const query = new URLSearchParams(urlSearchParams).toString();
  return query ? "?" + query : "";
}

/**
 * Утилитный тип: требует, чтобы в T был заполнен хотя бы один из Keys,
 * и делает выбранное поле обязательным
 */
export type RequireAtLeastOne<T, Keys extends keyof T = keyof T> = {
  [K in Keys]: Required<Pick<T, K>> & Partial<Omit<T, K>>;
}[Keys];
